import { render, staticRenderFns } from "./TeamCardSkeleton.vue?vue&type=template&id=558a0611"
import script from "./TeamCardSkeleton.vue?vue&type=script&lang=js"
export * from "./TeamCardSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports